import native from "src/constants/native";
import canNativeShare from "../../helpers/canNativeShare";
import getUniqueTypes from "../../helpers/getUniqueTypes";
import isValidDataTypes from "../../helpers/isValidDataTypes";
import { PickSharePayloadData, SharePayloadData } from "../../types";

const SupportedShareInstagramDMFormats = ["Text", "Url", "Image", "LivePhoto"] as const;

export type ShareInstagramDMDataType = PickSharePayloadData<
	typeof SupportedShareInstagramDMFormats
>;

export const isValidShareInstagramDMPayload = (
	data: SharePayloadData,
	{
		isIgAvailable,
	}: {
		isIgAvailable: boolean;
	},
): data is ShareInstagramDMDataType => {
	return (
		canNativeShare &&
		native &&
		isIgAvailable &&
		data.length === 1 &&
		isValidDataTypes(SupportedShareInstagramDMFormats, getUniqueTypes(data))
	);
};
